import { useEffect } from "react"
import { AddressType } from "../../static/types/commonTypes/addressType"
import useValidation from "../../hooks/useValidation"
import addressValidationSchema from "../../utils/validation/addressValidationSchema"
import PostalCodeField from "./PostalCodeField"
import useAppContext from "../../hooks/useAppContext"
import { AppContextType } from "../../context/AppContext"

type identityProps = {
    checked: boolean,
    address: AddressType,
    draftFieldName?: string,
    changeAddress: (partialIdentity: Partial<AddressType>) => void,
    onValidationChange: (isValid: boolean) => void
}

export default function Address({
    checked,
    address,
    draftFieldName,
    changeAddress,
    onValidationChange
}: identityProps) {

    const { draftFormData, setDraftFormData } = useAppContext() as AppContextType

    const { errors, isValid } = useValidation(address, addressValidationSchema)
    
    const stringifyDraft = ( data: any ) => { return JSON.stringify( data )}
    const parseDraft: any = () => { return draftFormData ? JSON.parse( draftFormData ) : {} }

    useEffect( () => {
        onValidationChange( isValid )

        let fieldName = draftFieldName ?? 'address'
        const draft = parseDraft()
        const tempDraft = { ...draft, [ fieldName ]: address }
        setDraftFormData( stringifyDraft( tempDraft ))

    }, [ isValid, onValidationChange ])

    return (
        <div className="mt-3">
            <div className="row mb-2">
                <label htmlFor="address" className="col-sm-2 col-form-label">
                    Adresse <strong className="text-danger">*</strong>
                </label>
                <div className="col-sm-6">
                    <input
                        className={`form-control ${checked && errors.address ? 'is-invalid' : ''}`}
                        type="text"
                        name="address"
                        id="address"
                        value={address.address}
                        onChange={event => changeAddress({ address: event.target.value })}
                    />
                    {checked && errors.address && <div className="invalid-feedback">{errors.address}</div>}
                </div>
            </div>

            <div className="row mb-2">
                <label htmlFor="additionalAddress" className="col-sm-2 col-form-label">
                    Adresse suite
                </label>
                <div className="col-sm-6">
                    <input
                        className="form-control"
                        type="text"
                        id="additionalAddress"
                        value={address.additionalAddress}
                        onChange={event => changeAddress({ additionalAddress: event.target.value })}
                    />
                </div>
            </div>

            <div className="row" style={{ marginLeft: '-0.5rem' }}>
                <PostalCodeField
                    checked={checked}
                    errors={errors}
                    onChange={changeAddress}
                    postalCode={address.postalCode}
                />
            </div>

            <div className="row">
                <label htmlFor="city" className="col-sm-2 col-form-label">
                    Ville <strong className="text-danger">*</strong>
                </label>
                <div className="col-sm-6">
                    <select
                        className={`form-select ${checked && errors.city ? 'is-invalid' : ''}`}
                        id="city"
                        onChange={event => changeAddress({ city: event.target.value })}
                    >
                        {address.cities?.map((city, key) => (
                            <option key={key} value={city}>
                                {city}
                            </option>
                        ))}
                    </select>
                    {checked && errors.city && <div className="invalid-feedback">{errors.city}</div>}
                </div>
            </div>
        </div>
    )
}
